export default "__VITE_PUBLIC_ASSET__b103437e__"